var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"block"}},[_c('q-icon',{attrs:{"name":_vm.severityConfig.mdiIcon,"color":_vm.severityConfig.mdiIconColor}}),_vm._v(" "+_vm._s(_vm.message)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }